//Constant for empty string
export const EMPTY_STRING = "";

export const DEFAULT_CURRENCY_ID = 147;

//Global constants for API response
export const globalConstants = {
  REQUEST: "_REQUEST",
  SUCCESS: "_SUCCESS",
  FAILURE: "_FAILURE",
  SPINNER_ACTIVATE: "SPINNER_ACTIVATE",
  SPINNER_DIACTIVATE: "SPINNER_DIACTIVATE",
  SET_SAVE_CHANGES: "SET_SAVE_CHANGES",
  IS_CONFORMATION_MODAL: "IS_CONFORMATION_MODAL",
  SET_SELECTED_ROW_ID: "SET_SELECTED_ROW_ID",
};

export const featureCategories = {
  MAIN: 1,
  ROOMS: 2,
  OTHERS: 3,
};

export const initialPagination = {
  pageSize: 10,
  pageNumber: 0,
  orderBy: "",
  search: "",
  filterQuery: "",
  filterData: "",
};

export const INPUT_TYPE = {
  TEXT: "text",
  EMAIL: "email",
  NUMBER: "number",
  PASSWORD: "password",
  TEL: "tel",
  URL: "url",
  DATE: "date",
  FILE: "file",
  RADIO: "radio",
  RANGE: "range",
  CHECKBOX: "checkbox",
};

export const SCREEN_PATH = {
  LOGIN: "/",
  HOME: "/home",
  FAVOURITES: "/favourites",
  PROPERTY_DETAIL: "/property-detail/:propertyId",
  FAVOURITES_PROPERTY_DETAIL: "/favourite-property-detail/:propertyId",
  MY_PROFILE: "/my-profile",
  ABOUT_US: "/about-us",
  CONTACT_US: "/contact-us",
  AGENT_ABOUT_US: "/agent/about-us",
  AGENT_CONTACT_US: "/agent/contact-us",
  MY_LISTING: "/agent/my-listing",
  AGENT_PROPERTY_DETAILS: "/agent/my-listing/:propertyId",
  EDIT_PROPERTY: "/agent/my-listing/:id/edit",
  CREATE_LISTING: "/agent/create-listing",
  AGENT_PROFILE: "/agent/profile",
  ADMIN_DASHBOARD: "/admin/dashboard",
  ADMIN_SUB_ADMINS: "/admin/users/sub-admins",
  ADMIN_AGENTS: "/admin/users/agents",
  ADMIN_AGENT_DETAILS: "/admin/users/agents/:id",
  ADMIN_AGENT_PROPERTIES: "/admin/users/agents/:id/properties",
  ADMIN_AGENT_PROPERTY_DETAILS:
    "/admin/users/agents/:id/properties/:propertyId",
  ADMIN_CUSTOMERS: "/admin/users/customers",
  ADMIN_CUSTOMERS_DETAILS: "/admin/users/customers/:id",
  ADMIN_PROPERTIES: "/admin/properties",
  ADMIN_PROPERTY_DETAILS: "/admin/property-detail/:propertyId",
  ADMIN_PAYMENTS: "/admin/payment-history",
  ADMIN_COUNTRIES: "/admin/settings/countries",
  ADMIN_COUNTRIES_DETAILS: "/admin/settings/countries/:id",
  ADMIN_COUNTRIES_ADD: "/admin/settings/countries/add-country",
  ADMIN_SUBSCRIPTION: "/admin/settings/subscription",
  ADMIN_PRIVACY_POLICY: "/admin/settings/privacy-policy",
  PRIVACY_POLICY: "/privacy-policy",
  AGENT_PRIVACY_POLICY: "/agent/privacy-policy",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  AGENT_TERMS_AND_CONDITIONS: "/agent/terms-and-conditions",
  ADMIN_TERMS_AND_CONDITIONS: "/admin/settings/terms-and-conditions",
  RESET_PASSWORD: "/reset-password",
  EMAIL_VERIFICATION: "/email-verification",
  ADMIN_FAQ: "/admin/settings/faq",
  FAQ: "/faq",
  AGENT_FAQ: "/agent/faq",
  SUBSCRIPTION_PLANS: "/subscription-plans",
  AGENT_SUBSCRIPTION_PLANS: "/agent/subscription-plans",
  MY_SUBSCRIPTIONS: "/my-subscriptions",
  AGENT_MY_SUBSCRIPTIONS: "/agent/my-subscriptions",
  COUNTRIES_ENCYCLOPEDIA: "/countries-encyclopedia",
  COUNTRY_ENCYCLOPEDIA_DETAIL:
    "/country-encyclopedia-detail/:countryEncyclopediaId",
  DEFAULT: "/",
};

export const buttonTypes = {
  CLOSE: "Close",
  CONFIRM: "Confirm",
};

export const COLOR = {
  WHITE: "#FFFFFF",
  BLACK: "#000000",
  TEAL: "#22d5d5",
  TEAL_HOVER: "#0eb0b0",
  RED: "#d9534f",
  TRANSPARENT: "transparent",
  NAVY_BLUE: "#0a1d47"
};

export const ROLE_ADMIN = 1;
export const ROLE_AGENT = 3;
export const ROLE_USER = 4;

export const VERIFICATION_TOKEN = "verificationToken";

export const routeValidationMessage =
  "You still need to save your listing? You will lose any info you added or changed if you leave this page";

export const PAYLOAD_KEYS = {
  FILTER_QUERY: "filterQuery",
  PAGE_NUMBER: "pageNumber",
  PAGE_SIZE: "pageSize",
  SEARCH: "search",
  ORDER_BY: "orderBy",
};

export const BUILD_QUERY_KEYS = {
  STRING: "string",
  CONTAINS: "Contains",
  PHONE_NUMBER: "PhoneNumber",
};

export const CONFIRMATION_MESSAGE = "Are you sure you want to change status?";
